import { createFileRoute, redirect } from '@tanstack/react-router'

import { scopeStore } from '@/lib/api/client'

/**
 * `/` on its own opens where the day starts in the scope `_app` settled on: the console's
 * Overview for the platform, the evaluations in an org.
 */
export const Route = createFileRoute('/_app/')({
  beforeLoad: () => {
    if (scopeStore.get()?.kind === 'platform') {
      throw redirect({ to: '/platform/overview', replace: true })
    }
    throw redirect({ to: '/evaluations', replace: true })
  },
})
